/*
 * @Author: LiGang
 * @Date: 2024-05-13 18:42:27
 * @LastEditors: LG liganglig@outlook.com
 * @LastEditTime: 2024-08-28 17:17:19
 * @FilePath: /parkH5New/src/store/state.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */
export const state = {
  accessToken: {
    accessToken: '123'
    // accessToken: ''
  },
  userAccountPass: {
    userAccountPass: null
  },
  accountRole: {
    accountRole: 1 // 1是社会人士普通用户   2是商户
    // accountRole: 'business'
  },
  code: {
    code: 123456
  },
  historyCode: {
    historyCode: 123457
  },
  sid: {
    sid: null
    // sid: 'testD'
  },
  channelPathID: {
    channelPathID: null
  },
  channelPath: {
    channelPath: null
  },
  queryLogHistory: {
    queryLogHistory: []
  },
  wxZfbAuthInfo: {
    wxZfbAuthInfo: null
  },
  phone: {
    phone: null
  },
  plateNumber: {
    plateNumber: null
  },
  adverInfo: {
    adverInfo: null
  },
  payType: {
    payType: null
  },
  saveRouteQueryData: {
    saveRouteQueryData: null
  },
  appid: {
    appid: null
  },
  myCarList: {
    myCarList: null
  },
  openID: {
    openID: null
  },
  applyBillInfo: {
    applyBillInfo: null
  },
  escapeInfo: {
    escapeInfo: null
  },
  payMonthCompleteInfo: {
    payMonthCompleteInfo: null
  }
}
